import { useState } from 'react';
import Button from '../base/Button';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  const navigateToServiceAreas = () => {
    if (window.REACT_APP_NAVIGATE) {
      window.REACT_APP_NAVIGATE('/service-areas');
    }
    setIsMenuOpen(false);
  };

  const handleCall = () => {
    window.location.href = 'tel:0491121950';
  };

  return (
    <header className="bg-black shadow-md fixed w-full top-0 z-50">
      <nav className="px-6 py-2">
        <div className="flex items-center justify-between max-w-7xl mx-auto">
          <div className="flex items-center">
            <a href="/" className="cursor-pointer">
              <h1>
                <img 
                  src="https://static.readdy.ai/image/cd116a5342bbace3e474cedd10298d09/a291ff05f9b53baf12128e234c5c6aff.jpeg"
                  alt="Starlight Motors Mobile Detailing"
                  title="Starlight Motors Mobile Detailing Melbourne"
                  className="h-12 w-auto object-contain"
                />
              </h1>
            </a>
          </div>
          
          <div className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('home')}
              className="text-white hover:text-teal-400 font-medium transition-colors cursor-pointer"
            >
              Home
            </button>
            <button 
              onClick={() => scrollToSection('about')}
              className="text-white hover:text-teal-400 font-medium transition-colors cursor-pointer"
            >
              About
            </button>
            <button 
              onClick={() => scrollToSection('services')}
              className="text-white hover:text-teal-400 font-medium transition-colors cursor-pointer"
            >
              Services
            </button>
            <button 
              onClick={navigateToServiceAreas}
              className="text-white hover:text-teal-400 font-medium transition-colors cursor-pointer"
            >
              Service Areas
            </button>
            <button 
              onClick={() => scrollToSection('testimonials')}
              className="text-white hover:text-teal-400 font-medium transition-colors cursor-pointer"
            >
              Reviews
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="text-white hover:text-teal-400 font-medium transition-colors cursor-pointer"
            >
              Contact
            </button>
            <Button 
              onClick={handleCall}
              size="sm"
            >
              Call Now
            </Button>
          </div>

          <button 
            className="md:hidden w-6 h-6 flex items-center justify-center cursor-pointer"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl text-white`}></i>
          </button>
        </div>

        {isMenuOpen && (
          <div className="md:hidden mt-3 pb-3 border-t border-gray-700">
            <div className="flex flex-col space-y-3 pt-4">
              <button 
                onClick={() => scrollToSection('home')}
                className="text-white hover:text-teal-400 font-medium transition-colors cursor-pointer text-left"
              >
                Home
              </button>
              <button 
                onClick={() => scrollToSection('about')}
                className="text-white hover:text-teal-400 font-medium transition-colors cursor-pointer text-left"
              >
                About
              </button>
              <button 
                onClick={() => scrollToSection('services')}
                className="text-white hover:text-teal-400 font-medium transition-colors cursor-pointer text-left"
              >
                Services
              </button>
              <button 
                onClick={navigateToServiceAreas}
                className="text-white hover:text-teal-400 font-medium transition-colors cursor-pointer text-left"
              >
                Service Areas
              </button>
              <button 
                onClick={() => scrollToSection('testimonials')}
                className="text-white hover:text-teal-400 font-medium transition-colors cursor-pointer text-left"
              >
                Reviews
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className="text-white hover:text-teal-400 font-medium transition-colors cursor-pointer text-left"
              >
                Contact
              </button>
              <Button 
                onClick={handleCall}
                size="sm"
                className="w-fit"
              >
                Call Now
              </Button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}
